import React, {useEffect, useState} from 'react';
import {useForm} from "react-hook-form";
import {Markup} from 'interweave';
import apiFetch from '@wordpress/api-fetch';
import {__} from '@wordpress/i18n';
import {useClassRegistrationFormStore} from "./store";
import PersonForm from "./PersonForm";

const App = () => {
  const [variantDates, setVariantDates] = useState();
  const [availableDateIds, setAvailableDateIds] = useState([]);
  const [currentVariantId, setCurrentVariantId] = useState(0);
  const [availableVariantIds, setAvailableVariantIds] = useState([]);
  const [currentDate, setCurrentDate] = useState(null);
  const [currentDateId, setCurrentDateId] = useState(0);
  const [fillSecondPerson, setFillSecondPerson] = useState(tanecniskola_class_registration.is_only_for_couples);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formAlert, setFormAlert] = useState({class: '', message: ''});
  const {register, handleSubmit, resetField, setValue, formState: {errors}} = useForm();

  // Store data.
  const isOnlyFormWomen = useClassRegistrationFormStore((state) => state.isOnlyFormWomen);
  const availableSex = useClassRegistrationFormStore((state) => state.availableSex);
  const firstPersonSex = useClassRegistrationFormStore((state) => state.firstPersonSex);
  const secondPersonSex = useClassRegistrationFormStore((state) => state.secondPersonSex);
  const setAvailableSex = useClassRegistrationFormStore((state) => state.setAvailableSex);
  const setFirstPersonSex = useClassRegistrationFormStore((state) => state.setFirstPersonSex);
  const setSecondPersonSex = useClassRegistrationFormStore((state) => state.setSecondPersonSex);

  useEffect(() => {
    if (tanecniskola_class_registration.variants && tanecniskola_class_registration.variants.length > 0) {
      const availableVariantIds = tanecniskola_class_registration.dates
        .filter(date => date.occupancy.some(o => o.is_available))
        .map(date => date.variant_id);
      console.log(tanecniskola_class_registration.dates, availableVariantIds);
      setAvailableVariantIds(availableVariantIds);
    } else {
      setVariantDates(tanecniskola_class_registration.dates);
    }
  }, []);

  useEffect(() => {
    if (availableVariantIds && availableVariantIds.length > 0) {
      setCurrentVariantId(availableVariantIds[0]);
    }
  }, [availableVariantIds]);

  useEffect(() => {
    if (currentVariantId > 0 && tanecniskola_class_registration.dates) {
      let variantDates = tanecniskola_class_registration.dates.filter(item => {
        return item.variant_id === currentVariantId;
      });
      let variantDateIds = variantDates.map(item => {
        return item.id;
      });

      setVariantDates(variantDates);
      setAvailableDateIds(variantDateIds);
    }
  }, [currentVariantId]);

  useEffect(() => {
    if (typeof variantDates === 'undefined') {
      return;
    }

    if (variantDates.length > 0) {
      let dateIds = variantDates.filter(item => {
        let availableSex = item.occupancy.filter(date => {
          return date.is_available;
        });
        return ((tanecniskola_class_registration.is_only_for_couples && availableSex.length === 2) || (!tanecniskola_class_registration.is_only_for_couples && availableSex.length > 0));
      }).map(item => {
        return item.id;
      });

      if (dateIds.length > 0) {
        setAvailableDateIds(dateIds);
      } else {
        setFormAlert({
          class: 'warning',
          message: __('Aktuálně nejsou vypsané žádné termíny k přihlášení.', 'tanecniskola')
        });
      }
    } else {
      setFormAlert({class: 'warning', message: __('Aktuálně nejsou vypsané žádné termíny k přihlášení.', 'tanecniskola')});
    }
  }, [variantDates]);

  useEffect(() => {
    if (0 === currentDateId) {
      return;
    }

    let currentDate = variantDates.filter((item) => {
      return item.id === currentDateId;
    });

    if (!currentDate.length) {
      return;
    }

    let availableSex = currentDate[0].occupancy.filter((item) => {
      return item.is_available;
    }).map(item => {
      return item.id;
    });
    setCurrentDate(currentDate[0]);
    setAvailableSex(availableSex);
  }, [currentDateId])

  useEffect(() => {
    if (availableDateIds.length) {
      setCurrentDateId(availableDateIds[0]);
    } else {
      setCurrentDateId(0);
    }
  }, [availableDateIds]);

  useEffect(() => {
    if (availableSex.length) {
      setFirstPersonSex(availableSex[0]);
    }

    if (!tanecniskola_class_registration.is_only_for_couples && availableSex.length < 2) {
      setFillSecondPerson(false);
    }
  }, [availableSex]);

  useEffect(() => {
    if (firstPersonSex === 'male') {
      setSecondPersonSex('female');
    } else {
      setSecondPersonSex('male');
    }
  }, [firstPersonSex]);

  useEffect(() => {
    if (!fillSecondPerson) {
      resetField('second_name');
      resetField('second_surname');
      resetField('second_street');
      resetField('second_city');
      resetField('second_zip');
      resetField('second_phone');
      resetField('second_email');
    }
  }, [fillSecondPerson]);

  const onSubmit = (formData) => {
    if (!isSubmitting) {
      sendFormData(formData);
    }
  }

  const sendFormData = (formData) => {
    formData['class_id'] = tanecniskola_class_registration.class_id;
    formData['date_id'] = currentDateId;
    formData['first_person_sex'] = firstPersonSex;
    if (fillSecondPerson) {
      formData['second_person_sex'] = secondPersonSex;
    }

    setIsSubmitting(true);

    apiFetch({
      path: tanecniskola.api_path + '/form/class-registration/',
      method: 'POST',
      data: formData,
    })
      .then((response) => {
        let formAlert;
        if (response.code) {
          formAlert = {
            class: 'error',
            message: response.message
          };
        } else {
          formAlert = {
            class: '',
            message: response.message
          };
          formAlert.class = (response.success) ? 'success' : 'error';
        }
        setFormAlert(formAlert);
        setIsSubmitting(false);
      });
  };

  return (
    <form method="POST" onSubmit={handleSubmit(onSubmit)}>
      <header className="form__header form__header--center">
        <div className="form__title">{tanecniskola_class_registration.class_name}</div>
        <h2>{__('Přihlaste se na kurz', 'tanecniskola')}</h2>
        {'' !== tanecniskola_class_registration.form_note &&
          <p className="form__note"><Markup content={tanecniskola_class_registration.form_note} noWrap={true}/></p>
        }

        {'' !== formAlert.message && 'error' !== formAlert.class &&
          <div className={`alert alert--${formAlert.class}`}>
            <p>{formAlert.message}</p>
          </div>
        }
      </header>

      {'' === formAlert.message &&
        <>
          {tanecniskola_class_registration.variants.length > 0 &&
            <>
              <div className="form__row">
                <div className="form__column">
                  <label className="form__label">{__('Zvolte variantu kurzu', 'tanecniskola')}</label>
                  <div className="form__radio-buttons form__radio-buttons--horizontal">
                    {tanecniskola_class_registration.variants.map((item, index) => {
                      return (
                        <div className="form__radio" key={item.id}>
                          <input type="radio" id={`variant-${item.id}`} value={item.id}
                                 checked={(currentVariantId === item.id)}
                                 disabled={!availableVariantIds.includes(item.id)}
                                 onChange={(e) => {
                                   setCurrentVariantId(parseInt(e.target.value));
                                 }}
                                 autoComplete="off"
                                 required
                          />
                          <label htmlFor={`variant-${item.id}`}>
                            {item.title}
                            {!availableVariantIds.includes(item.id) &&
                              <div className='form__error'>
                                {__('Kapacita je již naplněna.', 'tanecniskola')}
                              </div>
                            }
                          </label>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </>
          }

          <div className="form__row">
            <div className="form__column">
              <label className="form__label">{__('Výběr termínu', 'tanecniskola')}</label>
              <div className="form__radio-buttons">
                {(typeof variantDates !== 'undefined') &&
                  variantDates.map((item, index) => {
                    return (
                      <div className="form__radio" key={item.id}>
                        <input type="radio" id={`date-${item.id}`} value={item.id}
                               {...register("date_id")}
                               checked={(currentDateId === item.id)}
                               disabled={!availableDateIds.includes(item.id)}
                               onChange={(e) => {
                                 setCurrentDateId(parseInt(e.target.value));
                               }}
                               autoComplete="off"
                               required
                        />
                        <label htmlFor={`date-${item.id}`}>
                          {item.title} <small>({item.price})</small>
                          {!availableDateIds.includes(item.id) &&
                            <div className='form__error'>
                              {__('Kapacita je již naplněna.', 'tanecniskola')}
                            </div>
                          }
                        </label>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>

          <PersonForm
            inputPrefix="first_person_"
            sexSectionLabel={(isOnlyFormWomen) ? __('Tanečnice', 'tanecniskola') : __('Tanečnice/tanečník', 'tanecniskola')}
            personSex={firstPersonSex}
            setPersonSex={setFirstPersonSex}
            register={register}
            errors={errors}
          />

          {!isOnlyFormWomen && availableSex.length > 1 &&
            <div className="form__row">
              <div className="form__column">
                <div className="form__checkbox">
                  <input type="checkbox" name="fill_second_person" id="fill_second_person"
                         autoComplete="off"
                         checked={fillSecondPerson}
                         disabled={tanecniskola_class_registration.is_only_for_couples}
                         onChange={e => setFillSecondPerson(e.target.checked)}
                  />
                  <label htmlFor="fill_second_person">{__('Přihlašuji pár', 'tanecniskola')}</label>
                  <svg xmlns="http://www.w3.org/2000/svg" width="13.25" height="9.5" viewBox="0 0 13.25 9.5">
                    <path id="Path_3266" data-name="Path 3266" d="M8.75,15.5a1,1,0,0,1-.707-.293l-3.75-3.75a1,1,0,0,1,1.414-1.414L8.75,13.086l6.793-6.793a1,1,0,1,1,1.414,1.414l-7.5,7.5A1,1,0,0,1,8.75,15.5Z" transform="translate(-4 -6)" fill="#fff"/>
                  </svg>
                </div>
              </div>
            </div>
          }

          {!isOnlyFormWomen && fillSecondPerson &&
            <PersonForm
              inputPrefix="second_person_"
              sexSectionLabel={__('Partner/partnerka', 'tanecniskola')}
              personSex={secondPersonSex}
              setPersonSex={setSecondPersonSex}
              register={register}
              errors={errors}
            />
          }

          <footer className="form__footer">
            {currentDate &&
              <div className="form__price">
                <span>{__('Cena kurzu:', 'tanecniskola')}</span>
                <strong>{currentDate.price}</strong>
              </div>
            }

            <div className="form__terms">
              <Markup content={tanecniskola_class_registration.terms_label} noWrap={true}/>
            </div>

            {'' !== formAlert.message && 'error' === formAlert.class &&
              <div className="form__error">{formAlert.message}</div>
            }

            <div className="form__button">
              <button type="submit" className={`button button--${tanecniskola_class_registration.main_color}`}>
              <span>{
                (isSubmitting) ? (
                  __('Odesílám formulář...', 'tanecniskola')
                ) : (
                  __('Potvrdit přihlášení na kurz', 'tanecniskola')
                )
              }</span>
              </button>
            </div>
          </footer>
        </>
      }
    </form>
  )
    ;
}

document.addEventListener("DOMContentLoaded", function (event) {
  const items = document.querySelectorAll('.app-form-class-registration');
  if (items) {
    items.forEach(item => {
      ReactDOM.render(<App/>, item)
    });
  }
});
